import { IEnumOption } from 'modules/shared/interfaces/enumOptions';

export enum NotificationsRedirectToScreen {
	MAP = 'MAP',
	CULTURAL_CARDS = 'CULTURAL_CARDS',
	WORD_REVIEW = 'WORD_REVIEW',
	LIVE_SESSIONS = 'LIVE_SESSIONS',
	PROFILE = 'PROFILE',
	SHOP = 'SHOP',
}

export const NotificationsRedirectToScreenEnumOptions: IEnumOption[] = [
	{
		label: 'Map',
		value: NotificationsRedirectToScreen.MAP,
	},
	{
		label: 'Cultural',
		value: NotificationsRedirectToScreen.CULTURAL_CARDS,
	},
	{
		label: 'Strengthen',
		value: NotificationsRedirectToScreen.WORD_REVIEW,
	},
	{
		label: 'Live session',
		value: NotificationsRedirectToScreen.LIVE_SESSIONS,
	},
	{
		label: 'Profile',
		value: NotificationsRedirectToScreen.PROFILE,
	},
	{
		label: 'Souq',
		value: NotificationsRedirectToScreen.SHOP,
	},
];
